import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import CurrencyInput from 'react-currency-input-field';
import {
  deleteData,
  formatCurrency,
  getAlert,
  getDataWithComp,
  getData,  
  getDataWithJoin,
  insertData,
  parseCurrency,
  updateData,
  updateQty,
} from "../../../../utils/SamuiUtils";
import { useNavigate } from "react-router-dom";
import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import ViewHistoryItem from "../../../components/Modal/ViewHistoryItem";
const Form = ({
  callInitialize,
  onCancel,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
}) => {

  const requiredFields = ["item_code", "item_name"];

  const RequiredLabel = ({ label, field }) => (
    <label>
      {label}
      {requiredFields.includes(field) && (
        <span className="text-danger"> *</span>
      )}
    </label>
  );
  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent shortcuts when typing in input fields
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT') {
        return;
      }

      // ESC key - Cancel/Back
      if (event.key === 'Escape') {
        event.preventDefault();
        if (window.confirm('ต้องการยกเลิกการทำงานหรือไม่?')) {
          onCancel?.();
        }
      }

      // F10 key - Save
      if (event.key === 'F10') {
        event.preventDefault();
        if (mode === 'I') return; 
        if (mode === 'U') {
          confirmAndUpdate();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const [whDataList, setWhDataList] = useState([]);
  const [unitDataList, setUnitDataList] = useState([]);
  const [brandDataList, setBrandDataList] = useState([])
  const [groupDataList, setGroupDataList] = useState([])
  const [colourDataList, setColourDataList] = useState([])
  const [catDataList, setCatDataList] = useState([])
  const [prodCatList, setProdCatList] = useState([]);
  const [itmTypeList, setItmTypeList] = useState([]);
  const [sizeDataList, setSizeDataList] = useState([])

  const [beginAmount, setBeginAmount] = useState(0);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);

  const navigate = useNavigate();

  // Helper: read item type from selectedData with multiple possible field names
  const resolveItemType = (sd) => {
    if (!sd) return "";
    const candidates = [
      "Item_Type",
      "ItemType",
      "Item_TypeID",
      "Item_Type_Id",
      "item_type",
      "itemType",
    ];
    for (const key of candidates) {
      if (Object.prototype.hasOwnProperty.call(sd, key) && sd[key] !== undefined && sd[key] !== null && sd[key] !== "") {
        return String(parseCurrency(sd[key], 10));
      }
    }
    // fallback to Item_Series if present
    if (sd.Item_Series !== undefined && sd.Item_Series !== null && sd.Item_Series !== "") {
      return String(parseCurrency(sd.Item_Series, 10));
    }
    return "";
  };

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        item_id: "",
        comp_id: parseCurrency(window.localStorage.getItem("company")),
        item_barcode: "",
        item_code: "",
        item_name: "",
        item_name_en: "",
        item_short_name: "",
        item_unit_in: "",
        item_unit_st: "",
        item_unit_out: "",
        item_cost: "",
        item_price: "",
        item_pricea: "",
        item_priceb: "",
        item_brand: "",
        item_series: null,
        item_type: "",
        item_prodcat: "",
        item_group: "",
        item_cat: "",
        item_colour: "",
        item_size: "",
        item_status: "",
        item_popoint: "",
        item_maxonhand: "",
        ap_code: "",
        item_gold: "",
        item_onhand: "",
        item_wh: "",
        item_wholesale_price: "",
      };
      initialize();
      setFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        item_id: parseCurrency(selectedData.Item_Id, 10),
        comp_id: parseCurrency(selectedData.Comp_Id, 10),
        item_barcode: selectedData.Item_Barcode,
        item_code: selectedData.Item_Code,
        item_name: selectedData.Item_Name,
        item_name_en: selectedData.Item_Name_EN,
        item_short_name: selectedData.Item_Short_Name,
        item_unit_in: selectedData.Item_Unit_IN,
        item_unit_st: selectedData.Item_Unit_ST,
        item_unit_out: selectedData.Item_Unit_OUT,
        item_cost: selectedData.Item_Cost,
        item_price: selectedData.Item_Price,
        item_pricea: selectedData.Item_PriceA,
        item_priceb: selectedData.Item_PriceB,
        item_brand: selectedData.Item_Brand,
        item_series: selectedData.Item_Series || null,
        item_type: resolveItemType(selectedData),
        item_prodcat: "",
        item_group: selectedData.Item_Group,
        item_cat: selectedData.Item_Cat,
        item_colour: selectedData.Item_Colour,
        item_size: selectedData.Item_Size,
        item_status: selectedData.Item_Status,
        item_popoint: parseCurrency(selectedData.Item_PoPoint, 10),
        item_maxonhand: parseCurrency(selectedData.Item_MaxOnhand, 10),
        ap_code: selectedData.AP_Code,
        item_gold: parseCurrency(selectedData.Item_Gold),
        item_onhand: parseCurrency(selectedData.Item_Onhand, 10),
        item_wh: selectedData.Item_WH,
        item_wholesale_price: selectedData.Item_Wholesale_price,
      };
      initialize();
      setFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const initialize = async () => {
    try {
      const unitDataList = await getDataWithComp('Tb_Set_Unit', `AND Unit_Status = 'Y' ORDER BY Unit_Id ASC`);
      if (unitDataList && unitDataList.length > 0) {
        // setUnitDataList([])
        setUnitDataList(unitDataList);
      }
      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_WH
      const whDataList = await getDataWithComp('Tb_Set_WH', `AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`);
      if (whDataList && whDataList.length > 0) {
        // setWhDataList([])
        setWhDataList(whDataList);
      }
      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmBrand
      const brandDataList = await getDataWithComp('Tb_Set_ItmBrand', `AND Brand_Status = 'Y' ORDER BY Brand_Id ASC`);
      if (brandDataList && brandDataList.length > 0) {
        // setWhDataList([])
        setBrandDataList(brandDataList);
      }

      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmGroup
      const groupDataList = await getDataWithComp('Tb_Set_ItmGroup', `AND Group_Status = 'Y' ORDER BY Group_Id ASC`);
      if (groupDataList && groupDataList.length > 0) {
        // setWhDataList([])
        setGroupDataList(groupDataList);
      }

      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmGroup
      const colourDataList = await getDataWithComp('Tb_Set_ItmColour', `AND Colour_Status = 'Y' ORDER BY Colour_Id ASC`);
      if (colourDataList && colourDataList.length > 0) {
        // setWhDataList([])
        setColourDataList(colourDataList);
      }

      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmCat
      const catDataList = await getDataWithComp('Tb_Set_ItmCat', `AND Cat_Status = 'Y' ORDER BY Cat_Id ASC`);
      if (catDataList && catDataList.length > 0) {
        // setWhDataList([])
        setCatDataList(catDataList);
      }
      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmGroup
      const sizeDataList = await getDataWithComp('Tb_Set_ItmSize', `AND Size_Status = 'Y' ORDER BY Size_Id ASC`);
      if (sizeDataList && sizeDataList.length > 0) {
        // setWhDataList([])
        setSizeDataList(sizeDataList);
      }
      // ดึงข้อมูล ProdCategory
      const prodCats = await getDataWithComp('Tb_Set_ProdCategory', `AND ProdCat_Status = 'Y' ORDER BY ProdCat_Id ASC`);
      if (prodCats && prodCats.length > 0) {
        setProdCatList(prodCats);
      }
      // ดึงข้อมูล ItmType
      const itmTypes = await getDataWithComp('Tb_Set_ItmType', `AND ItmType_Status = 'Y' ORDER BY ItmType_Id ASC`);
      if (itmTypes && itmTypes.length > 0) {
        setItmTypeList(itmTypes);
      }

      if (mode === 'U') {
        const currentItmTypeId = resolveItemType(selectedData) || formData.item_type;
        if (currentItmTypeId && itmTypes && itmTypes.length > 0) {
          const found = itmTypes.find((t) => parseCurrency(t.ItmType_Id, 10) === parseCurrency(currentItmTypeId, 10));
          if (found) {
            setFormData((prev) => ({ ...prev, item_prodcat: found.ProdCat_Id }));
          }
        }
      }
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "item_type") {
      const newData = { ...formData, [name]: value };
      const found = itmTypeList.find((t) => String(parseCurrency(t.ItmType_Id, 10)) === String(value));
      if (found && found.ProdCat_Id !== undefined && found.ProdCat_Id !== null) {
        newData.item_prodcat = String(parseCurrency(found.ProdCat_Id, 10));
      } else {
        newData.item_prodcat = "";
      }
      setFormData(newData);
      return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleCurrencyChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertTbsetItem = async () => {
    try {
      const { item_id, ...dataToInsert } = formData;

      const unitInId = unitDataList.find(u => u.Unit_Name === formData.item_unit_in)?.Unit_Id || null;
      const unitStId = unitDataList.find(u => u.Unit_Name === formData.item_unit_st)?.Unit_Id || null;
      const unitOutId = unitDataList.find(u => u.Unit_Name === formData.item_unit_out)?.Unit_Id || null;

      const sanitizeData = (data) => {
        const sanitized = { ...data };
        // แปลงค่าที่เป็น string ว่างให้เป็น 0 สำหรับฟิลด์ตัวเลข
        sanitized.item_cost = data.item_cost === "" ? 0 : data.item_cost;
        sanitized.item_price = data.item_price === "" ? 0 : data.item_price;
        sanitized.item_pricea = data.item_pricea === "" ? 0 : data.item_pricea;
        sanitized.item_priceb = data.item_priceb === "" ? 0 : data.item_priceb;
        sanitized.item_popoint =
          data.item_popoint === "" ? 0 : data.item_popoint;
        sanitized.item_maxonhand =
          data.item_maxonhand === "" ? 0 : data.item_maxonhand;
        sanitized.item_gold = data.item_gold === "" ? 0 : data.item_gold;
        sanitized.item_onhand = data.item_onhand === "" ? 0 : data.item_onhand;

        sanitized.unit_in_id = unitInId;
        sanitized.unit_st_id = unitStId;
        sanitized.unit_out_id = unitOutId;

        // ทดสอบดูก่อนว่าได้ไหม
        sanitized.item_status = data.item_status === "" ? "Y" : data.item_status;
        sanitized.item_sprice_use = "N";

        sanitized.item_wholesale_price = data.item_wholesale_price === "" ? 0 : data.item_wholesale_price;

        sanitized.item_type = data.item_type === "" || data.item_type == null ? null : parseCurrency(data.item_type, 10);

        if (sanitized.item_prodcat !== undefined) {
          delete sanitized.item_prodcat;
        }

        return sanitized;
      };

      const sanitizedData = sanitizeData(dataToInsert);

      const fields = Object.keys(sanitizedData).join(", ");
      const values = Object.values(sanitizedData);
      const res = await insertData("Tb_Set_Item", fields, values);

      if (res?.status === "OK") {
        // ทำการ auto ไปอยู่คลังนั้นเลย กรณี สร้างสินค้าใหม่
        const getItemData = await getDataWithComp(
          "Tb_Set_Item",
          `
            AND Item_Code = '${dataToInsert.item_code}' 
            AND Item_Name = '${dataToInsert.item_name}' 
            AND Item_WH = '${dataToInsert.item_wh}' 
            AND Item_Status = 'Y'
          `
        );
        if (getItemData && getItemData.length > 0) {
          await manageWhItemData(
            getItemData[0].Item_Id, // Item ไอดีของสิ่งนั้นๆ
            dataToInsert.item_code, // Item โค้ดของสิ่งนั้นๆ
            dataToInsert.item_name, // ชื่อ Item นั้นๆ
            parseCurrency(dataToInsert.item_wh), // WarehouseID ของไอเทม
            "BG", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(beginAmount || 0), // ค่าจำนวนที่กรอกจากหน้าจอ
            null, // ไอดีเอกสาร
            "เริ่มต้นคลัง", // เลขเอกสาร
            "เริ่มต้นคลัง", // เลขเอกสารอ้างอิง
            null // หมายเหตุ
          );
        }

        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }

    } catch (error) {
      console.error("Error inserting data:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
    }
  };

  const formatValues = (data) => {
    const { item_id, ...rest } = data;
    return rest;
  };

  const handleUpdateTbsetItem = async () => {
    try {
      const unitInId = unitDataList.find(u => u.Unit_Name === formData.item_unit_in)?.Unit_Id || null;
      const unitStId = unitDataList.find(u => u.Unit_Name === formData.item_unit_st)?.Unit_Id || null;
      const unitOutId = unitDataList.find(u => u.Unit_Name === formData.item_unit_out)?.Unit_Id || null;

      const where = { item_id: formData.item_id };
      const values = {
        ...formatValues(formData),
        item_type: formData.item_type === "" || formData.item_type == null ? null : parseCurrency(formData.item_type, 10),
        unit_in_id: unitInId,
        unit_st_id: unitStId,
        unit_out_id: unitOutId
      };

      // Remove UI-only `item_prodcat` from update payload to avoid invalid column
      if (values.item_prodcat !== undefined) {
        delete values.item_prodcat;
      }

      const res = await updateData("Tb_Set_Item", values, where);
      if (res) {

        // ตอนที่อัพเดทชื่อสินค้า ให้ไป อัพเดทชื่อสินค้าที่ onHand ด้วย
        await updateQty(
          "WH_ITEM_Onhand",
          `Item_Name = '${formData.item_name}'`,
          `WHERE Item_Id = ${parseCurrency(formData.item_id)}`
        );

        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize(formData.item_id ?? selectedData?.Item_Id ?? selectedData?.item_id);
      }
    } catch (error) {
      console.error("Error updating item:", error);
      getAlert("FAILED", "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว");
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Item",
            `WHERE Item_Id = ${selectedData.Item_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const confirmAndUpdate = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการแก้ไขข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await handleUpdateTbsetItem();
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (mode === "I") {
        await handleInsertTbsetItem();
      } else if (mode === "U") {
        await handleUpdateTbsetItem();
      }
      setFormData({
        item_id: "", // Int
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
        item_barcode: "",
        item_code: "",
        item_name: "",
        item_name_en: "",
        item_short_name: "",
        item_unit_in: "",
        item_unit_st: "",
        item_unit_out: "",
        item_cost: "",
        item_price: "",
        item_pricea: "",
        item_priceb: "",
        item_brand: "",
        item_series: null,
        item_type: "",
        item_group: "",
        item_cat: "",
        item_color: "",
        item_size: "",
        item_status: "",
        item_popoint: "",
        item_maxonhand: "",
        ap_code: "",
        item_gold: "",
        item_onhand: "",
        item_wh: "",
        item_wholesale_price: "",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const checkItemCode = async () => {
    const { item_id, ...dataToInsert } = formData;

    const resItemCode = await getDataWithJoin(
      `a.*`,
      `[dbo].[Tb_Set_Item] AS a`,
      `WHERE a.Item_Code = '${formData.item_code}'`, ""
    );

    if (resItemCode && resItemCode.length > 0) {
      getAlert("FAILED", "มีรหัสสินค้าแล้ว");
      setFormData((prev) => ({ ...prev, item_code: "" }));
    } else {
      getAlert("SUCCESS", "รหัสสินค้านี้สามารถใช้ได้");
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/tbsetitem" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            {mode === "U" && (
              <div className="d-flex justify-content-end mb-3">
                <button type="button"
                  className="btn btn-lg text-white"
                  style={{ padding: '12px', backgroundColor: '#EF6C00' }}
                  onClick={() => setIsHistoryOpen(true)}
                >
                  ดูประวัติการซื้อสินค้า
                </button>
              </div>
            )}
            {/* กลุ่ม: ข้อมูลสินค้า */}
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลสินค้า</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <RequiredLabel label="รหัสสินค้า" field="item_code" />
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_code"
                  maxLength={20}
                  value={formData.item_code || ""}
                  onChange={handleChange}
                  onBlur={checkItemCode}
                />
              </div>
              <div className="col-md-6">
                <RequiredLabel label="Barcode" field="item_barcode" />
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_barcode"
                  maxLength={20}
                  value={formData.item_barcode || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row g-3 mt-2">
              <div className="col-md-4">
                <RequiredLabel label="ชื่อสินค้า" field="item_name" />
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_name"
                  maxLength={200}
                  value={formData.item_name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <RequiredLabel label="ชื่อสินค้าภาษาอังกฤษ" field="item_name_en" />
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_name_en"
                  maxLength={200}
                  value={formData.item_name_en || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <RequiredLabel label="ชื่อสินค้าแบบย่อ" field="item_short_name" />
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_short_name"
                  maxLength={50}
                  value={formData.item_short_name || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* กลุ่ม: ข้อมูลคลังและหน่วย */}
            <div className="mt-4"></div>
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลคลังและหน่วย</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>เลือกคลัง</label>
                <div className="input-group">
                  <select
                    name="item_wh"
                    className="form-select input-spacing"
                    value={formData.item_wh || ""}
                    onChange={(e) => {
                      handleChange(e);
                      setBeginAmount("");
                    }}
                    disabled={whDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกคลัง</option>
                    {whDataList.map((ware) => (
                      <option key={ware.WH_Id} value={ware.WH_Id}>{ware.WH_Name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <label>จำนวนเริ่มต้นคลัง</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="beginAmount"
                  value={beginAmount || ""}
                  onChange={(e) => setBeginAmount(e.target.value)}
                  onFocus={() => {
                    setBeginAmount(parseCurrency(beginAmount.replace(/,/g, "")));
                  }}
                  onBlur={() => {
                    setBeginAmount(formatCurrency(parseCurrency(beginAmount)));
                  }}
                  disabled={!formData.item_wh || mode === "U"}
                  onInput={(e) => {
                    const inputValue = e.target.value;
                    if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                      e.target.value = inputValue.slice(0, -1);
                    }
                  }}
                />
              </div>
              <div className="col-md-2">
                <label>หน่วยรับเข้า</label>
                <div className="input-group">
                  <select
                    name="item_unit_in"
                    className="form-select input-spacing"
                    value={formData.item_unit_in || ""}
                    onChange={handleChange}
                    disabled={unitDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกหน่วยรับเข้า</option>
                    {unitDataList.map((unit_in) => (
                      <option key={unit_in.Unit_Id} value={unit_in.Unit_Name}>{unit_in.Unit_Name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <label>หน่วยในคลัง</label>
                <div className="input-group">
                  <select
                    name="item_unit_st"
                    className="form-select input-spacing"
                    value={formData.item_unit_st || ""}
                    onChange={handleChange}
                    disabled={unitDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกหน่วยในคลัง</option>
                    {unitDataList.map((unit_st) => (
                      <option key={unit_st.Unit_Id} value={unit_st.Unit_Name}>{unit_st.Unit_Name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <label>หน่วยส่งออก</label>
                <div className="input-group">
                  <select
                    name="item_unit_out"
                    className="form-select input-spacing"
                    value={formData.item_unit_out || ""}
                    onChange={handleChange}
                    disabled={unitDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกหน่วยส่งออก</option>
                    {unitDataList.map((unit_out) => (
                      <option key={unit_out.Unit_Id} value={unit_out.Unit_Name}>{unit_out.Unit_Name}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* กลุ่ม: ข้อมูลราคา */}
            <div className="mt-4"></div>
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลราคา</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>ต้นทุนสินค้า</label>
                <CurrencyInput
                  maxLength={10}
                  decimalsLimit={2}
                  decimalScale={2}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="item_cost"
                  value={formData.item_cost || ""}
                  onValueChange={(value, name) => handleCurrencyChange(value, name)}
                />
              </div>
              <div className="col-md-4">
                <label>ราคาสินค้า</label>
                <CurrencyInput
                  maxLength={10}
                  decimalsLimit={2}
                  decimalScale={2}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="item_price"
                  value={formData.item_price || ""}
                  onValueChange={(value, name) => handleCurrencyChange(value, name)}
                />
              </div>
              <div className="col-md-4">
                <label>ราคาขายส่ง</label>
                <CurrencyInput
                  maxLength={10}
                  decimalsLimit={2}
                  decimalScale={2}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="item_wholesale_price"
                  value={formData.item_wholesale_price || ""}
                  onValueChange={(value, name) => handleCurrencyChange(value, name)}
                />
              </div>
              <div className="col-md-4">
                <label>ราคาสินค้าA</label>
                <CurrencyInput
                  maxLength={10}
                  decimalsLimit={2}
                  decimalScale={2}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="item_pricea"
                  value={formData.item_pricea || ""}
                  onValueChange={(value, name) => handleCurrencyChange(value, name)}
                />
              </div>
              <div className="col-md-4">
                <label>ราคาสินค้าB</label>
                <CurrencyInput
                  maxLength={10}
                  decimalsLimit={2}
                  decimalScale={2}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="item_priceb"
                  value={formData.item_priceb || ""}
                  onValueChange={(value, name) => handleCurrencyChange(value, name)}
                />
              </div>
            </div>

            {/* กลุ่ม: ข้อมูลหมวดหมู่และคุณสมบัติ */}
            <div className="mt-4"></div>
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลหมวดหมู่และคุณสมบัติ</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>แบรนด์สินค้า</label>
                <div className="input-group">
                  <select
                    name="item_brand"
                    className="form-select input-spacing"
                    value={formData.item_brand || ""}
                    onChange={handleChange}
                    disabled={brandDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกแบรนด์สินค้า</option>
                    {brandDataList.map((brand) => (
                      <option key={brand.Brand_id} value={brand.Brand_Code}>{brand.Brand_Name}</option>
                    ))}
                  </select>
                  {brandDataList.length <= 0 && (
                    <button onClick={() => navigate("/brand")}
                      className="btn btn-lg text-white"
                      style={{ padding: '12px', borderRadius: "0 5px 5px 0", backgroundColor: '#EF6C00' }}
                      type="button">+</button>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <label>กลุ่มสินค้า</label>
                <div className="input-group">
                  <select
                    name="item_group"
                    className="form-select input-spacing"
                    value={formData.item_group || ""}
                    onChange={handleChange}
                    disabled={groupDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกกลุ่มสินค้า</option>
                    {groupDataList.map((group) => (
                      <option key={group.Group_Id} value={group.Group_Id}>{group.Group_Name}</option>
                    ))}
                  </select>
                  {groupDataList.length <= 0 && (
                    <button onClick={() => navigate("/tb-set-group")}
                      className="btn btn-lg text-white"
                      style={{ padding: '12px', borderRadius: "0 5px 5px 0", backgroundColor: '#EF6C00' }}
                      type="button">+</button>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <label>ประเภทสินค้า</label>
                <div className="input-group">
                  <select
                    name="item_cat"
                    className="form-select input-spacing"
                    value={formData.item_cat || ""}
                    onChange={handleChange}
                    disabled={catDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกประเภทสินค้า</option>
                    {catDataList.map((cat) => (
                      <option key={cat.Cat_Id} value={cat.Cat_Code}>{cat.Cat_Name}</option>
                    ))}
                  </select>
                  {catDataList.length <= 0 && (
                    <button onClick={() => navigate("/tb-set-cat")}
                      className="btn btn-lg text-white"
                      style={{ padding: '12px', borderRadius: "0 5px 5px 0", backgroundColor: '#EF6C00' }}
                      type="button">+</button>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <label>ประเภทค่าใช้จ่าย</label>
                <div className="input-group">
                  <select
                    name="item_type"
                    className="form-select input-spacing"
                    value={formData.item_type || ""}
                    onChange={handleChange}
                    disabled={itmTypeList.length <= 0}
                  >
                    <option value={""}>กรุณาเลือกประเภทค่าใช้จ่าย</option>
                    {itmTypeList.map((t) => (
                      <option key={t.ItmType_Id} value={t.ItmType_Id}>{t.ItmType_Name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4">
                <label>หมวดหมู่สินค้า</label>
                <div className="input-group">
                  <select
                    name="item_prodcat"
                    className="form-select input-spacing"
                    value={formData.item_prodcat || ""}
                    disabled={true}
                    onChange={(e) => {
                      handleChange(e);
                      setFormData((prev) => ({ ...prev, item_type: "" }));
                    }}
                  >
                    <option value={""}>กรุณาเลือกหมวดหมู่สินค้า</option>
                    {prodCatList.map((pc) => (
                      <option key={pc.ProdCat_Id} value={pc.ProdCat_Id}>{pc.ProdCat_Name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4">
                <label>สี</label>
                <div className="input-group">
                  <select
                    name="item_colour"
                    className="form-select input-spacing"
                    value={formData.item_colour || ""}
                    onChange={handleChange}
                    disabled={colourDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกสีของสินค้า</option>
                    {colourDataList.map((colour) => (
                      <option key={colour.Colour_Id} value={colour.Colour_Code}>{colour.Colour_Name}</option>
                    ))}
                  </select>
                  {colourDataList.length <= 0 && (
                    <button onClick={() => navigate("/tb-set-colour")}
                      className="btn btn-lg text-white"
                      style={{ padding: '12px', borderRadius: "0 5px 5px 0", backgroundColor: '#EF6C00' }}
                      type="button">+</button>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <label>ขนาด</label>
                <div className="input-group">
                  <select
                    name="item_size"
                    className="form-select input-spacing"
                    value={formData.item_size || ""}
                    onChange={handleChange}
                    disabled={sizeDataList.length <= 0}
                  >
                    <option value={''}>กรุณาเลือกขนาดสินค้า</option>
                    {sizeDataList.map((size) => (
                      <option key={size.Size_Id} value={size.Size_Code}>{size.Size_Name}</option>
                    ))}
                  </select>
                  {sizeDataList.length <= 0 && (
                    <button onClick={() => navigate("/tb-set-size")}
                      className="btn btn-lg text-white"
                      style={{ padding: '12px', borderRadius: "0 5px 5px 0", backgroundColor: '#EF6C00' }}
                      type="button">+</button>
                  )}
                </div>
              </div>
            </div>

            {/* กลุ่ม: ข้อมูลควบคุมสต๊อค */}
            <div className="mt-4"></div>
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลควบคุมสต๊อค</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>จุดสั่งซื้อ</label>
                <CurrencyInput
                  maxLength={10}
                  allowDecimals={false}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="item_popoint"
                  value={formData.item_popoint || ""}
                  onValueChange={(value, name) => handleCurrencyChange(value, name)}
                />
              </div>
              <div className="col-md-4">
                <label>จำนวนสูงสุดในสต๊อค</label>
                <CurrencyInput
                  maxLength={10}
                  allowDecimals={false}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="item_maxonhand"
                  value={formData.item_maxonhand || ""}
                  onValueChange={(value, name) => handleCurrencyChange(value, name)}
                />
              </div>
              <div className="col-md-4">
                <label>สถานะ</label>
                <select
                  className="form-select"
                  name="item_status"
                  value={formData.item_status || "Y"}
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>
            {/* ปุ่ม Action */}
            <div className="row mt-4">
              {mode !== "I" ? (
                <div className="d-flex justify-content-between align-items-center">
                  <button onClick={handleDelete} type="button" className="btn btn-danger btn-lg">ลบ</button>
                  <div className="d-flex gap-2">
                    <button onClick={() => onCancel?.()} type="button" className="btn btn-dark btn-lg">ยกเลิก</button>
                    <button onClick={confirmAndUpdate} type="button" className="btn btn-warning text-white btn-lg">บันทึก</button>
                  </div>
                </div>
              ) : (
                <div className="d-flex">
                  <FormAction onSubmit={handleSubmit} onUpdate={handleSubmit} onDelete={handleDelete} mode={mode} />
                </div>
              )}
            </div>
            <ViewHistoryItem
              open={isHistoryOpen}
              onClose={() => setIsHistoryOpen(false)}
              itemId={parseCurrency(formData?.item_id || selectedData?.Item_Id, 10)}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
